// extracted by mini-css-extract-plugin
module.exports = {"list":"List-module__list___182r_","item":"List-module__item___2TlEM"};